import {
  AdsBadge,
  SolutionBadge,
  SolutionBusinessBadge,
  SolutionDailyBadge,
} from '@components'
import { BannerAPI } from '@api'
import { Swiper, SwiperSlide } from 'swiper/react'
// import Swiper core and required modules
import SwiperCore, { Navigation, Pagination, Scrollbar, A11y } from 'swiper'
import './FirstSection.scss'
import 'swiper/swiper.scss'
import { useState, useEffect } from 'react'

SwiperCore.use([Navigation, Pagination, Scrollbar, A11y])

function FirstSection() {
  const [controller, setController] = useState(null)
  const [currentIndex, setCurrentIndex] = useState(0)

  const onNext = () => {
    controller.slideNext()
  }

  const onPrevious = () => {
    controller.slidePrev()
  }

  const [items, setItems] = useState([])

  useEffect(() => {
    async function loadData() {
      if (items.length < 1) {
        const bannerData = await BannerAPI({ loc: 'home_main' })
        setItems(bannerData.data.data)
      }
    }

    loadData()
  }, [items])

  return (
    <div className="home-first-section">
      <div className="row home-first-section-body">
        <div className="col-12 col-sm-8 left">
          <div className="carousel-main">
            <Swiper
              slidesPerView={1}
              centeredSlides={true}
              loop={true}
              onSwiper={(swiper) => setController(swiper)}
              onSlideChange={(swiper) =>
                swiper.realIndex === items.length - 1
                  ? setCurrentIndex(0)
                  : setCurrentIndex(swiper.realIndex + 1)
              }
            >
              {items
                .filter((data) => !!data.image)
                .map((data, i) => {
                  const background = encodeURI(data.image)
                  const bgImage = {
                    backgroundImage: `url(${background})`,
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center',
                    backgroundSize: 'cover',
                  }

                  // if carousel has link
                  if (data?.link !== null && data?.link !== "" && data?.link !== undefined) {
                    return (
                      <SwiperSlide key={`carousel-main-${i}`}>
                        <a href={data.link}>
                          <div
                            className="carousel-main-item"
                            style={bgImage}
                          >
                            <div className="carousel-main-item-body">
                              <h4>{data.title}</h4>
                              <p>{data.description}</p>
                            </div>
                          </div>
                        </a>
                      </SwiperSlide>
                    )
                  } else {
                    return (
                      <SwiperSlide key={`carousel-main-${i}`}>
                        <div className="carousel-main-item" style={bgImage}>
                          <div className="carousel-main-item-body">
                            <h4>{data.title}</h4>
                            <p>{data.description}</p>
                          </div>
                        </div>
                      </SwiperSlide>
                    )
                  }
                })}
            </Swiper>
            <div className="carousel-main-footer">
              <button
                className="btn btn-outline-primary d-flex"
                onClick={() => onPrevious()}
              >
                <i className="bi bi-chevron-left"></i>
              </button>
              <button
                className="btn btn-outline-primary d-flex"
                onClick={() => onNext()}
              >
                <i className="bi bi-chevron-right"></i>
              </button>
            </div>
            <div className="carousel-navigation">
              {items
                .filter((data) => !!data.image)
                .map((data, i) => (
                  <div
                    key={i}
                    className={`tile ${i === currentIndex ? 'active' : ''}`}
                  ></div>
                ))}
            </div>
          </div>
        </div>
        <div className="col-12 col-sm-4 right">
          <AdsBadge />
          <SolutionBusinessBadge className="mr" />
          <SolutionDailyBadge className="mr" />
          <SolutionBadge className="mr" />
        </div>
      </div>
    </div>
  )
}

export default FirstSection
